module.exports = __webpack_public_path__ + "static/media/covid2.6b4db550.jpg";